// TERMINAL CONFIGURATIONS FOR DIFFERENT TERMINAL TYPES

import StandaloneTerminalBg from '../../../assets/images/terminal/terminal-background.png';
import OPTTerminalBg from '../../../assets/images/terminal/opt.png';
import UnattendedSelf5000Bg from '../../../assets/images/terminal/self-5000.png';
import UnattendedPAXIM30Bg from '../../../assets/images/terminal/pax-im30.png';
// Import additional terminal background images here when available
// import POSTerminalBg from '../../../assets/images/terminal/pos-terminal-background.png';

export const STANDALONE_CONFIG = {
  // Layout and background image configuration
  layout: {
    backgroundImage: StandaloneTerminalBg,
    aspectRatio: '400/600',
    minHeight: '800px',
    maxWidth: 'max-w-2xl',
  },
  
  // Terminal positioning (percentages) - ADJUST THESE TO MOVE THE UI AROUND
  screen: {
    top: '25%',      // How far down the screen starts - INCREASE to move UI down
    left: '25%',     // Left margin - INCREASE to move UI right
    right: '22%',    // Right margin - INCREASE to move UI left  
    bottom: '18%',   // Bottom margin - INCREASE to move UI up
  },
  
  // UI Component sizing - ADJUST THESE TO CHANGE BUTTON SIZES AND SPACING
  ui: {
    maxWidth: 'max-w-xs',        // Width constraint for UI elements
    keypadButtonHeight: 'h-14',   // Height of keypad buttons (h-6, h-8, h-10, h-12)
    keypadGap: 'gap-2',          // Gap between keypad buttons (gap-0, gap-1, gap-2)
    keypadMargin: 'mb-2',        // Margin below keypad (mb-1, mb-2, mb-3)
    backgroundColor: 'bg-gray-100', // Background color (bg-white, bg-gray-50, bg-gray-100)
  },
  
  // AI Response settings
  ai: {
    defaultVerbosity: 1,         // Default verbosity level (0=Brief, 1=Standard, 2=Detailed)
    showVerbosityControl: true,  // Show verbosity slider in UI
  }
};

export const POS_CONFIG = {
  // Layout and background image configuration
  layout: {
    backgroundImage: StandaloneTerminalBg, // Use same for now, change when POS image available
    aspectRatio: '300/500', // Different aspect ratio for POS terminal
    minHeight: '600px',
    maxWidth: 'max-w-md',
  },
  
  // POS integrated terminal - compact layout
  screen: {
    top: '20%',
    left: '10%',
    right: '10%',
    bottom: '30%',
  },
  
  ui: {
    maxWidth: 'max-w-xs',
    keypadButtonHeight: 'h-6',
    keypadGap: 'gap-0',
    keypadMargin: 'mb-1',
    backgroundColor: 'bg-white',
  },
  
  // AI Response settings
  ai: {
    defaultVerbosity: 1,
    showVerbosityControl: true,
  }
};

export const UNATTENDED_SELF5000_CONFIG = {
  // Layout and background image configuration for Self-5000 terminal
  layout: {
    backgroundImage: UnattendedSelf5000Bg,
    aspectRatio: '800/1000', // Unattended terminal aspect ratio
    minHeight: '800px',
    maxWidth: 'max-w-4xl',
    backgroundSize: 'bg-contain',
    containerClass: '-mt-28',
  },
  
  // Unattended Self-5000 terminal - large layout
  screen: {
    top: '19%',
    left: '29%',
    right: '28%',
    bottom: '34%',
  },
  
  ui: {
    maxWidth: 'max-w-md',
    keypadButtonHeight: 'h-14',
    keypadGap: 'gap-2',
    keypadMargin: 'mb-1',
    backgroundColor: 'bg-white',
  },
  
  // AI Response settings
  ai: {
    defaultVerbosity: 1,
    showVerbosityControl: true,
  }
};

export const UNATTENDED_PAXIM30_CONFIG = {
  // Layout and background image configuration for PAX IM30 terminal
  layout: {
    backgroundImage: UnattendedPAXIM30Bg,
    aspectRatio: '800/1000', // Similar aspect ratio to Self-5000
    minHeight: '700px',
    maxWidth: 'max-w-2xl',
    backgroundSize: 'bg-contain',
    containerClass: '-mt-0',
  },
  
  // Unattended PAX IM30 terminal - large layout
  screen: {
    top: '12%',
    left: '22%',
    right: '26%',
    bottom: '12%',
  },
  
  // UI Component sizing - ADJUST THESE TO CHANGE BUTTON SIZES AND SPACING
  ui: {
    maxWidth: 'max-w-sm',        // Width constraint for UI elements
    keypadButtonHeight: 'h-10',   // Height of keypad buttons (h-6, h-8, h-10, h-12)
    keypadGap: 'gap-2',          // Gap between keypad buttons (gap-0, gap-1, gap-2)
    keypadMargin: 'mb-2',        // Margin below keypad (mb-1, mb-2, mb-3)
    backgroundColor: 'bg-gray-100', // Background color (bg-white, bg-gray-50, bg-gray-100)
  },
  
  // AI Response settings
  ai: {
    defaultVerbosity: 1,
    showVerbosityControl: true,
  }
};

// Backward compatibility - keep UNATTENDED_CONFIG pointing to Self-5000 for now
export const UNATTENDED_CONFIG = UNATTENDED_SELF5000_CONFIG;

export const OPT_CONFIG = {
  // Layout and background image configuration for Outdoor Payment Terminal
  layout: {
    backgroundImage: OPTTerminalBg,
    aspectRatio: 'auto', // Let image use natural proportions
    minHeight: '100vh', // Full viewport height
    maxWidth: 'max-w-none', // Remove width constraints
    backgroundSize: 'bg-contain', // Show full image without cropping
    containerClass: 'absolute top-16 left-0 right-0', // Position absolute from navbar bottom
  },
  
  // OPT fuel pump terminal - large outdoor layout
  screen: {
    top: '18%',
    left: '18%',
    right: '48%',
    bottom: '40%',
  },
  
  ui: {
    maxWidth: 'max-w-lg',
    keypadButtonHeight: 'h-12',
    keypadGap: 'gap-2',
    keypadMargin: 'mb-3',
    backgroundColor: 'bg-white',
  },
  
  // AI Response settings
  ai: {
    defaultVerbosity: 1,
    showVerbosityControl: true,
  }
};